import React, { useState } from "react";
import { createPortal } from "react-dom";
import FeedbackModal from "./FeedbackModal";
import {config} from "Utils/config"

const setFeedback = config.publicFeedback;

const Feedback = ({ label = "Feedback", top = 300, zIndex = 1040 }) => {
    const [show, setShow] = useState(false);
    
    const trigger = (
      <div
        className="feedback-trigger-container"
        style={{
            top,
            zIndex,
        }}
      >
        <button
          className="feedback-trigger"
          type="button"
          aria-label="Open feedback form"
          onClick={() => setShow(true)}
        >
        <span
          className="feedback-label"
        >
          {label}
        </span>
          </button>
      </div>
    );
    if (!setFeedback) return null;
    return (
      <>
          {createPortal(trigger, document.body)}
          <FeedbackModal show={show} onHide={() => setShow(false)} />
      </>
    );
};

export default Feedback;
